module.exports = __webpack_public_path__ + "img/certificate01.652aea07.png";